import axios from 'axios';
import { ONINVOICEMASTERAPIHOME, ONINVOICEDETAILAPIHOME, NRRAPIHOME } from './config';
import DealerDataDef from '../sections/dealer/dealerdatadef';

class OnlineEntryService {

    constructor() {

        this.GetColumns = (menuName) => (DealerDataDef(menuName));

        // Online entry invoice master
        this.GetInvoiceMasters = (payload) => (axios.post(`${ONINVOICEMASTERAPIHOME}getinvoicemasters`, payload));

        this.NewONInvoiceMaster = (payload) => (axios.post(`${ONINVOICEMASTERAPIHOME}newoninvoicemaster`, payload));

        this.GetAccountsInfo = () => (axios.post(`${ONINVOICEMASTERAPIHOME}getaccountsinfo`));

        this.GetDealersInfo = () => (axios.post(`${ONINVOICEMASTERAPIHOME}getdealersinfo`));

        this.UpdateONInvoiceMaster = (payload) => (axios.post(`${ONINVOICEMASTERAPIHOME}updateoninvoicemaster`, payload));

        this.GetSurgeonDetails = (searchKey) => (axios.post(`${ONINVOICEMASTERAPIHOME}getsurgeondetails`, { searchKey }));

        this.GetAccountDetails = (searchKey) => (axios.post(`${ONINVOICEMASTERAPIHOME}getaccountdetails`, { searchKey }));

        this.GetDealerDetails = (payload) => (axios.post(`${ONINVOICEMASTERAPIHOME}getdealerdetails`, payload));

        this.GetFranchiseByMonth = (payload) => (axios.post(`${ONINVOICEMASTERAPIHOME}getfranchisebymonth`, payload));

        this.GetEnableDataMode = (distributorId) => (axios.post(`${ONINVOICEMASTERAPIHOME}getenabledatamode`, { distributorId }));

        // Online entry invoice detail
        this.GetInvoiceDetails = (invoiceId) => (axios.post(`${ONINVOICEDETAILAPIHOME}getinvoicedetails`, { invoiceId }));

        this.NewONInvoiceDetail = (payload) => (axios.post(`${ONINVOICEDETAILAPIHOME}newoninvoicedetail`, payload));

        this.UpdateONInvoiceDetail = (payload) => (axios.post(`${ONINVOICEDETAILAPIHOME}updateoninvoicedetail`, payload));

        this.GetNetRealizationRateRecord = (payload) => (axios.post(`${NRRAPIHOME}getnetrealizationraterecord`, payload));

        this.GetDistProductPrice = (payload) => (axios.post(`${NRRAPIHOME}getdistproductprice`, payload));

        this.GetItemDetails = (payload) => (axios.post(`${ONINVOICEDETAILAPIHOME}getitemdetails`, payload));

        this.DeleteInvoiceDetail = (payload) => (axios.post(`${ONINVOICEDETAILAPIHOME}deleteinvoicedetail`, payload));

        this.GetSpecialMonth = () => (axios.post(`${ONINVOICEDETAILAPIHOME}getspecialmonth`));

        this.ProcessOnlineTransactions = (payload) => (axios.post(`${ONINVOICEMASTERAPIHOME}processonlinetransactions`, payload));

    }
}
export default new OnlineEntryService();